import Router from '@alltrails/shared/components/ReactRouter';
import { Context } from '@alltrails/shared/types/context';
import ApplicationLayout from 'components/ApplicationLayout/ApplicationLayout';
import CustomProvider from 'components/CustomProvider';
import SimpleProLandingPage from 'components/SimpleProLandingPage';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Coupon from 'types/Coupon';
import CurrencyCode from 'types/CurrencyCode';
import PaymentMethod from 'types/PaymentMethod';
import PlanTypeType from 'types/PlanTypeType';
import CheckoutRoute from './CheckoutRoute';
import LoginRoute from './LoginRoute';
import RegisterRoute from './RegisterRoute';

type SimpleRouterProps = {
  annualPlan: PlanTypeType;
  // layout props
  context: Context;
  coupon?: Coupon;
  currencyCode: CurrencyCode;
  currentPage: string;
  locationSlug: string;
  paymentTypes?: PaymentMethod[];
  planTypes: PlanTypeType[];
  recurlyPublicKey: string;
  userId?: number;
  web_growth_pro_checkout_page_v1: null | 'control' | 'new_checkout';
  wideFooter: boolean;
};

function SimpleRouter({
  currencyCode,
  recurlyPublicKey,
  paymentTypes,
  coupon,
  annualPlan,
  planTypes,
  userId,
  currentPage,
  locationSlug,
  context,
  wideFooter,
  web_growth_pro_checkout_page_v1
}: SimpleRouterProps) {
  const activePlanType = planTypes[0].planCode;

  return (
    <Router fullpath={global.__AT_DATA__.pathname}>
      <Switch>
        <Route path="/:locale?/signup">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <RegisterRoute coupon={coupon} />
          </ApplicationLayout>
        </Route>
        <Route path="/:locale?/login">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <LoginRoute coupon={coupon} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/pro">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <SimpleProLandingPage activePlanType={activePlanType} coupon={coupon} currencyCode={currencyCode} planTypes={planTypes} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route path="/:locale?/pro/checkout">
          <CheckoutRoute
            activePlanType={activePlanType}
            annualPlan={annualPlan}
            context={context}
            coupon={coupon}
            currencyCode={currencyCode}
            currentPage={currentPage}
            locationSlug={locationSlug}
            paymentTypes={paymentTypes}
            planTypes={planTypes}
            recurlyPublicKey={recurlyPublicKey}
            userId={userId}
            web_growth_pro_checkout_page_v1={web_growth_pro_checkout_page_v1}
            wideFooter={wideFooter}
          />
        </Route>
      </Switch>
    </Router>
  );
}

type Props = {
  annualPlan: PlanTypeType;
  // layout props
  context: Context;
  coupon?: Coupon;
  currencyCode: CurrencyCode;
  currentPage: string;
  experiments: { web_growth_pro_checkout_page_v1?: null | 'control' | 'new_checkout' };
  locationSlug: string;
  paymentTypes?: PaymentMethod[];
  planTypes?: PlanTypeType[];
  recurlyPublicKey: string;
  userId?: number;
  wideFooter: boolean;
};

export default function Pro({
  context,
  planTypes,
  paymentTypes,
  currencyCode,
  coupon,
  recurlyPublicKey,
  annualPlan,
  userId,
  wideFooter,
  currentPage,
  locationSlug,
  experiments
}: Props) {
  return (
    <CustomProvider>
      <SimpleRouter
        annualPlan={annualPlan}
        context={context}
        coupon={coupon}
        currencyCode={currencyCode}
        currentPage={currentPage}
        locationSlug={locationSlug}
        paymentTypes={paymentTypes}
        planTypes={planTypes}
        recurlyPublicKey={recurlyPublicKey}
        userId={userId}
        web_growth_pro_checkout_page_v1={experiments.web_growth_pro_checkout_page_v1}
        wideFooter={wideFooter}
      />
    </CustomProvider>
  );
}
